//已经集成到mixin.js
export default {
    data() {
        return {
            screenHeight:"",
        }
    },
    mounted() {
        this.$tableHeight = window.innerHeight;
        window.onresize = () => {

            return (() => {
                window.screenHeight = window.innerHeight;
                this.screenHeight = window.screenHeight;
            })();
        };
    },

    watch: {
        screenHeight(val) {
            this.$tableHeight = val;
        },

    },
}


// WEBPACK FOOTER //
// ./src/components/TagsView/tableHeight.js